import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { useState } from "react";

import useDesktopChecker from "hooks/useDesktopChecker";

import BannerCard from "components/v2/banner-card/BannerCard";
import NativeAppPromoModal, {
  useNativeAppPromoState,
} from "components/v2/native-app-promo-modal/NativeAppPromoModal";

import {
  NATIVE_APP_BANNER_GET_APP_LABEL,
  NATIVE_APP_BANNER_SCAN_QR_LABEL,
  NATIVE_APP_BANNER_SUBTITLE,
  NATIVE_APP_BANNER_TITLE,
} from "utilities/Constant";

interface NativeAppBannerCardProps {
  readonly onDismiss?: () => void;
  readonly className?: string;
  readonly isModalOpenByDefault?: boolean;
  readonly variant?: "desktop" | "mobile";
}

export default function NativeAppBannerCard({
  onDismiss,
  className,
  isModalOpenByDefault = false,
  variant,
}: NativeAppBannerCardProps) {
  const hookIsDesktop = useDesktopChecker();
  const isDesktop = variant ? variant === "desktop" : hookIsDesktop;
  const [isModalOpen, setIsModalOpen] = useState(isModalOpenByDefault);
  const { isQrOk, onQrError, shouldShowBadges, onBadgeError } = useNativeAppPromoState();

  const ctaLabel = isDesktop ? NATIVE_APP_BANNER_SCAN_QR_LABEL : NATIVE_APP_BANNER_GET_APP_LABEL;

  return (
    <>
      <BannerCard
        title={NATIVE_APP_BANNER_TITLE}
        subtitle={NATIVE_APP_BANNER_SUBTITLE}
        ctaLabel={ctaLabel}
        onCTAClick={() => setIsModalOpen(true)}
        onDismiss={onDismiss}
        icon={solid("mobile-alt")}
        variant={variant}
        className={className}
      />

      {isModalOpen && (
        <NativeAppPromoModal
          onClose={() => setIsModalOpen(false)}
          showQr={isQrOk}
          onQrError={onQrError}
          onBadgeError={onBadgeError}
          showAppStoreBadge={shouldShowBadges.appStore}
          showGooglePlayBadge={shouldShowBadges.googlePlay}
        />
      )}
    </>
  );
}
